import React, { createContext, useContext, useMemo, useState } from "react";

const AuthContext = createContext(null);

function safeParseUser(raw) {
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    localStorage.removeItem("auth_user");
    localStorage.removeItem("auth_token");
    return null;
  }
}

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const nextToken = localStorage.getItem("auth_token") || "";
    const rawUser = localStorage.getItem("auth_user");
    const parsedUser = safeParseUser(rawUser);

    if (nextToken && !parsedUser) {
      return "";
    }

    return nextToken;
  });
  const [user, setUser] = useState(() => safeParseUser(localStorage.getItem("auth_user")));

  const login = (nextToken, nextUser) => {
    localStorage.setItem("auth_token", nextToken);
    localStorage.setItem("auth_user", JSON.stringify(nextUser));
    setToken(nextToken);
    setUser(nextUser);
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    setToken("");
    setUser(null);
  };

  const value = useMemo(() => ({ token, user, login, logout, isAuthenticated: !!token }), [token, user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
